import { AbiItem } from "web3-utils";
import { addresses } from "./addresses"
import { networkId, web3 } from "./config"
import { Interface } from '@ethersproject/abi'
import { MultiCall } from "../types/MultiCall";
import { Token } from "../types/Token";

export const getToken = (token: string) => {
    return addresses[token][networkId] as Token;
}

export const getContractOf = (ABI: any, address: string) => {
    const contract = new web3.eth.Contract(
        (ABI as AbiItem),
        address
    );
    return contract;
}

export const cactiNFTContract = getContractOf(getToken('CactiNFT').abi, getToken('CactiNFT').address);
export const cactiTokenContract = getContractOf(getToken('CactiToken').abi, getToken('CactiToken').address);
export const multiCallContract = getContractOf(getToken('MultiCall').abi, getToken('MultiCall').address);
export const cactiStakingContract = getContractOf(getToken('CactiNFTStaking').abi, getToken('CactiNFTStaking').address);

/**
 * Multicall V2 uses the new "tryAggregate" function. It is different in 2 ways
 *
 * 1. If "requireSuccess" is false multicall will not bail out if one of the calls fails
 * 2. The return includes a boolean whether the call was successful e.g. [wasSuccessful, callResult]
 */
 export type MultiCallResponse<T> = T | null;

 export const multicallv2 = async <T = any>(abi: any[], calls: MultiCall[]): Promise<MultiCallResponse<T>> => {
   const itf = new Interface(abi)
 
   const calldata = calls.map((call) => [call.address.toLowerCase(), itf.encodeFunctionData(call.name, call.params)])
   const { returnData } = await multiCallContract.methods.aggregate(calldata).call()
   const res = returnData.map((call: any, i: number) => itf.decodeFunctionResult(calls[i].name, call))
 
   return res
 }
 